import { Injectable } from '@angular/core';
import { authConfig } from './auth-config';
declare let Keycloak: any;

@Injectable(
  { providedIn: 'root' }
)
export class KeycloackService {

  private keycloak = new Keycloak(authConfig);
  constructor() {
  }

  get istance() { return this.keycloak; }

}
